import React from 'react';
import locale from 'antd/lib/date-picker/locale/pt_BR';
import PropTypes from 'prop-types';
import {
  Form,
  Row,
  Col,
  DatePicker,
  InputNumber,
} from 'antd';
import moment from 'moment';
import './EstagioCorte.scss';

const EstagioCorteField = (props) => {
  const dateFormat = 'DD/MM/YYYY';

  const {
    rules,
    rulesData1,
    rulesData2,
    min,
    max,
    name,
    nameData1,
    nameData2,
    label,
    labelData1,
    labelData2,
    date1min,
    date2min,
    estagioCorteValue,
    dataUltimoCorte,
    dataPenultimoCorte,
    edit,
  } = props;

  return (
    <div>
      <Form.Item
        label={<span className="field-title-text">{label}</span>}
        name={name}
        rules={rules}
        initialValue={estagioCorteValue || undefined}
      >
        <InputNumber
          style={{ width: '100%' }}
          disabled={edit}
          {...(min !== null && max !== null ? { min, max } : {})}
        />
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={
          (previousValues, currentValues) => {
            return currentValues[name] !== previousValues[name];
          }
        }
      >
        {
          (formInstanceParameter) => {
            if (
              formInstanceParameter.getFieldValue(name) >= date1min
            ) {
              return (
                <Row gutter={24} className="inline-field">
                  <Col span={24}>
                    <Form.Item
                      label={<span className="field-title-text">{labelData1}</span>}
                      name={nameData1}
                      rules={rulesData1}
                      initialValue={dataUltimoCorte ? moment(dataUltimoCorte, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]') : undefined}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        disabled={edit}
                        locale={locale}
                        format={dateFormat}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              );
            }

            return null;
          }
        }
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={
          (previousValues, currentValues) => {
            return currentValues[name] !== previousValues[name];
          }
        }
      >
        {
          (formInstanceParameter) => {
            if (
              formInstanceParameter.getFieldValue(name) >= date2min
            ) {
              return (
                <Row gutter={24} className="inline-field">
                  <Col span={24}>
                    <Form.Item
                      label={<span className="field-title-text">{labelData2}</span>}
                      name={nameData2}
                      rules={rulesData2}
                      initialValue={dataPenultimoCorte ? moment(dataPenultimoCorte, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]') : undefined}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        disabled={edit}
                        locale={locale}
                        format={dateFormat}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              );
            }

            return null;
          }
        }
      </Form.Item>
    </div>
  );
};

EstagioCorteField.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rulesData1: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rulesData2: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  min: PropTypes.any,
  max: PropTypes.any,
  name: PropTypes.string.isRequired,
  nameData1: PropTypes.string.isRequired,
  nameData2: PropTypes.string.isRequired,
  label: PropTypes.element.isRequired,
  labelData1: PropTypes.element.isRequired,
  labelData2: PropTypes.element.isRequired,
  date1min: PropTypes.number.isRequired,
  date2min: PropTypes.number.isRequired,
  estagioCorteValue: PropTypes.number,
  dataUltimoCorte: PropTypes.any,
  dataPenultimoCorte: PropTypes.any,
  edit: PropTypes.bool,
};
EstagioCorteField.defaultProps = {};

export default EstagioCorteField;
